export default __webpack_public_path__ + "static/media/office_outside.089cf0ab.jpeg";